import {
  dehydrateApolloClient,
  getMaintainedParam,
  initApolloClient,
} from "../apolloClient";
import { GET_ALL_CITIES } from "../../graphql/queries/regions";
import { FIND_LISTINGS } from "../../graphql/queries/find.listings";
import categories from "@/lib/path-resolver-middlewares/ssr/categories";
import { getQuickFiltersCategoryFields } from "@/src/pages/api/[category]/fields";
import { TRENDY_FILTERS_BASED_ON_CATEGORY } from "@/lib/path-resolver-middlewares/ssr/trendy.filters";

export const DEFAULT_CATEGORY = {
  id: 0,
  name: "عقارات",
  plural: "عقارات",
  uri: "عقارات",
  path: "/عقارات",
  keywords: ["عقارات", "عقار", "للبيع", "للإيجار", "تأجير", "أجار"],
};
export const APPARTMENTS_CATEGORY = {
  id: 1,
  name: "شقة للإيجار",
  en: "Apartment for rent",
  ga_listing_type: "rent",
  ga_property_category: "apartment",
  is_rent: true,
  plural: "شقق للإيجار",
  uri: "شقق-للإيجار",
  path: "/شقق-للإيجار",
  keywords: ["شقة", "شقق", "للإيجار", "تأجير", "أجار"],
  description:
    "تصفح آلاف عقارات الشقق للايجار في جميع مدن ومناطق السعودية بأسعار ومساحات مناسبة بالصور والتفاصيل. مع الاطلاع على ميزة تقييم الحي في تطبيق عقار ، تطبيق عقار",
};
export const VILLAS_CATEGORY = {
  id: 5,
  ga_listing_type: "rent",
  ga_property_category: "villa",
  is_rent: true,
  name: "فيلا للإيجار",
  en: "Villa for rent",
  plural: "فلل للإيجار",
  uri: "فلل-للإيجار",
  path: "/فلل-للإيجار",
  keywords: [
    "فيلا",
    // "دوبلكس",
    "دبلكس",
    "دوبلكسات",
    "فلل",
    "للإيجار",
    "تأجير",
    "أجار",
    "فلل للإيجار",
  ],
  description:
    "ابحث عن فيلا أو دبلكس للايجار في جميع أحياء مدن ومناطق السعودية بإيجار سنوي أوشهري أويومي بمساحات مختلفة بأفضل الأسعار مع تصفح الصور والتفاصي ، تطبيق عقار",
};
export const FLAT_CATEGORY = {
  id: 4,
  ga_listing_type: "rent",
  ga_property_category: "flat",
  is_rent: true,
  name: "دور للإيجار",
  en: "Big flat for rent",
  plural: "دور للإيجار",
  uri: "دور-للإيجار",
  path: "/دور-للإيجار",
  keywords: ["دور", "أدوار", "للإيجار", "تأجير", "أجار"],
  description:
    "ادوار للايجار بأحياء الرياض و جدة و مكة والدمام و الخبر وجميع مدن ومناطق السعودية، يمكنك البحث عن دور ارضي أو أول أو ثاني بسعر مناسب على عقار ، تطبيق عقار",
};
const REDIRECTS_MAP = {
  "شقق-للحجز": encodeURIComponent("شقق-مفروشة-للحجز"),
  "استديوهات-للحجز": encodeURIComponent("استديوهات-مفروشة-للحجز"),
  "فلل-للحجز": "فلل-مفروشة-للحجز",
  "شقة-مفروشة": encodeURIComponent("شقق-للإيجار"),
  شمال: encodeURIComponent("الواجهة-شمال"),
  "شمال-شرقي": encodeURIComponent("الواجهة-شمال-شرقي"),
  "شمال-غربي": encodeURIComponent("الواجهة-شمال-غربي"),
  جنوب: encodeURIComponent("الواجهة-جنوب"),
  "جنوب-شرقي": encodeURIComponent("الواجهة-جنوب-شرقي"),
  "جنوب-غربي": encodeURIComponent("الواجهة-جنوب-غربي"),
  شرق: encodeURIComponent("الواجهة-شرق"),
  غرب: encodeURIComponent("الواجهة-غرب"),
  "3-شوارع": encodeURIComponent("تفتح-على-3-شوارع"),
  "4-شوارع": encodeURIComponent("تفتح-على-4-شوارع"),
};
const REDIRECTION_MAP_PARAMS = {
  "شقة-مفروشة": "furnished=eq,1",
};
export const isPage = new RegExp(/^[0-9]+$/);
export const hasId = new RegExp(/[0-9]+$/);
export const Category = {
  Resolve: async (ctx, $res) => {
    ctx.performance.categoryStart = Date.now();
    const { categories, description } = await import("./ssr/categories");
    const {
      getCategoryExtendedFields,
      getCategoryFields,
      getSearchCategoryFields,
      getQuickFiltersCategoryFields,
    } = await import("../../pages/api/[category]/fields");
    /**
     * Here I can query for listing by category and page if
     * it exists.
     * ctx: NextPageContext {req,query,...etc.}
     *
     * */

    const [category, page, plus] = (ctx?.query?.params || []).map(decodeURI);

    if (REDIRECTS_MAP[category]) {
      if (categories[REDIRECTS_MAP[category]]?.id > 100 && !ctx.path.isDaily) {
        return ctx.redirect(
          "/" +
            encodeURIComponent("الحجز-اليومي") +
            ctx.req.url.replace(
              encodeURIComponent(category),
              REDIRECTS_MAP[category],
            ),
        );
      }

      const [url, params] = ctx.req.url
        .replace(encodeURIComponent(category), REDIRECTS_MAP[category])
        .split("?");
      return ctx.redirect(
        [
          url,
          decodeURIComponent(
            [params, REDIRECTION_MAP_PARAMS[category]]
              .flat()
              .filter(Boolean)
              .join("&"),
          ),
        ].join("?"),
      );
    }
    if (categories[category]?.id > 100 && !ctx.path.isDaily) {
      return ctx.redirect(
        "/" + encodeURIComponent("الحجز-اليومي") + ctx.req.url,
      );
    }

    ctx.path.categories = Object.keys(categories)
      .map((key) => categories[key])
      .map((cat, i) => ({ ...cat, index: cat.id > 100 ? cat.id - 100 : i }));
    ctx.path.categoriesDictionary = ctx.path.categories.reduce(
      (acc, cat) => ({ ...acc, [cat.id]: cat }),
      {},
    );

    if (category && !categories[category]) {
      return ctx.redirect("/");
    }
    ctx.path.searchFields =
      getSearchCategoryFields(categories[category]?.id) || [];
    ctx.path.fields = getCategoryFields(categories[category]?.id) || [];
    ctx.path.extendedFields =
      getCategoryExtendedFields(categories[category]?.id) || [];

    ctx.path.category = categories[category || "عقارات"];
    ctx.path.quickFields =
      getQuickFiltersCategoryFields(ctx.path.category?.id) || [];
    if (plus) return {}; // resume to next;
    if (page && !isPage.test(page)) return {}; // resume to next;
    ctx.path.page = parseInt(page, 10) || 0;
    if (ctx.path.page === 1) {
      return ctx.redirect(ctx.req.url.replace(`/${page}`, ""));
    }

    ctx.path.category.description = description[category || "عقارات"]?.replace(
      /%place/g,
      "الرياض، جدة، الدمام، مكة، المدينة و جميع مناطق المملكة العربية السعودية" +
        (ctx.path.filtersAsText ? " " + ctx.path.filtersAsText : ""),
    );

    const client = initApolloClient();
    const pathFilters = ctx.path.filters || {};
    const { villa_type, ...filters } = pathFilters;
    const maintainedParam = getMaintainedParam(
      ctx.authState?.user?.cooperative,
    );
    await Promise.all([
      client.query({
        context: { aqarPlus: ctx.authState?.token },
        query: FIND_LISTINGS,
        variables: {
          size: 20,
          from: ((ctx.path.page || 1) - 1) * 20,
          sort: {
            create_time: "desc",
            has_img: "desc",
          },
          where: {
            ...(ctx.path?.category?.id
              ? {
                  category: {
                    eq: categories[category].id,
                  },
                }
              : {}),
            ...filters,
            ...(filters?.price_12_payments?.gte > 1
              ? {
                  price_12_payments: {
                    gte: filters.price_12_payments.gte * 12,
                  },
                }
              : {}),
            ...(villa_type?.eq && { villa_type: villa_type.eq }),
            unpublished: undefined,
            ...maintainedParam,
          },
          daily_renting_filter: ctx.path.daily_renting_filter,
        },
      }),
      client.query({
        query: GET_ALL_CITIES,
        variables: {
          category: categories[category]?.id || 0,
        },
      }),
    ]);

    ctx.performance.categoryEnd = Date.now();

    ctx.performance.categoryTook =
      ctx.performance.categoryEnd - ctx.performance.categoryStart;
    return $res(dehydrateApolloClient(client, {}));
  },
  async Trendy(ctx, $res) {
    /**
     *
     *  Process the filters from the query params and remove them from the query params
     * */
    const [category, ...params] = (ctx?.query?.params || []).map(decodeURI);
    if (!category || category === "عقارات") return;

    const hasRedirect = !!params.find((p) => REDIRECTS_MAP[p]);

    if (hasRedirect) {
      const [url, params] = ctx.req.url
        .replace(encodeURIComponent(category), REDIRECTS_MAP[category])
        .split("?");

      return ctx.redirect(
        [
          url,
          decodeURIComponent(
            [params, REDIRECTION_MAP_PARAMS[category]]
              .flat()
              .filter(Boolean)
              .join("&"),
          ),
        ].join("?"),
      );
    }

    const { TRENDY_FILTERS, TRENDY_FILTERS_BASED_ON_CATEGORY } = await import(
      "./ssr/trendy.filters"
    );

    const newParams = params.filter((p) => !TRENDY_FILTERS[p]);

    const filtersArr = params
      .filter((p) => TRENDY_FILTERS[p])
      .map((p) => ({
        ...TRENDY_FILTERS[p],
        url: p,
      }));

    if (
      filtersArr.find(
        (f) =>
          !TRENDY_FILTERS_BASED_ON_CATEGORY[categories[category]?.id]?.[f.url],
      )
    ) {
      ctx.res.statusCode = 404;
      throw `لا يمكنك استخدام هذا الفلتر في هذه الفئة`;
    }
    const filters = filtersArr.reduce(
      (acc, { url, seo, ...rest }) => ({ ...acc, ...rest }),
      {},
    );
    if (Object.keys(filters).length) {
      if (
        filters.price_2_payments ||
        filters.price_4_payments ||
        filters.price_12_payments
      ) {
        filters.rent_period = { eq: 3 };
      }
      ctx.path.filters = { ...ctx.path.filters, ...filters };
      ctx.path.hasFilters =
        ctx.path.hasFilters || !!Object.keys(filters).length;
      const filterAsPath = [""]
        .concat(...params.filter((p) => TRENDY_FILTERS[p]))
        .join("/");
      ctx.path.filterAsPath = filterAsPath;
      ctx.path.filtersAsText = params
        .filter((p) => TRENDY_FILTERS[p])
        .map((p) => TRENDY_FILTERS[p].seo?.title || p.replaceAll("-", " "))
        .join(" ");
      ctx.query.params = [category, ...newParams];
    }
  },
};
export default Category;
